import Switch from '@components/v2/form/Switch/Switch';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { GeneralSettingsParams } from '../../../../stores/GeneralSettings/generalSettings.types';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { ProductsAccessGeneralSettingsProps } from '../types/GeneralSettings.types';

const ProductsAccessGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
  handleChangeAndBlurList,
}: ProductsAccessGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_PRODUCTS_ACCESS)}
      description={LangEnum.GENERAL_SETTINGS_PRODUCTS_SECTION_DESCRIPTION}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_PRODUCTS_RESTRICT_TO_CATALOG_LABEL)}
          name="restrictProductsUsingCatalogs"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.restrictProductsUsingCatalogs}
          onChange={(event, checked) => {
            if (!checked) {
              handleChangeAndBlurList([
                {
                  value: false,
                  name: 'restrictProductsUsingCatalogs' as keyof GeneralSettingsParams,
                },
                {
                  value: false,
                  name: 'restrictProductsUsingCustomerCatalogs' as keyof GeneralSettingsParams,
                },
              ]);
            } else {
              handleChangeAndBlur({
                value: checked,
                name: event.target.name as keyof GeneralSettingsParams,
              });
            }
          }}
        />
        <Switch
          label={translate(
            LangEnum.GENERAL_SETTINGS_PRODUCTS_RESTRICT_PRODUCTS_USING_CUSTOMER_CATALOGS,
          )}
          name="restrictProductsUsingCustomerCatalogs"
          size="medium"
          sx={{ ml: 0 }}
          disabled={!generalSettings.restrictProductsUsingCatalogs}
          checked={generalSettings.restrictProductsUsingCustomerCatalogs}
          onChange={(event, checked) =>
            handleChangeAndBlur({
              value: checked,
              name: event.target.name as keyof GeneralSettingsParams,
            })
          }
        />
      </Stack>
    </SettingContainer>
  );
};

export default ProductsAccessGeneralSettings;
